import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ConsentUpdateService {
  private reloadConsent$: BehaviorSubject<void> = new BehaviorSubject<void>(undefined);

  public reloadConsentObservable$: Observable<void> = this.reloadConsent$.asObservable();

  public triggerReload(): void {
    this.reloadConsent$.next();
  }
}
